"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgMapMarker(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M11.936 0c4.937 0 8.936 4.02 8.936 8.98 0 3.37-1.597 6.864-4.243 10.308a34.455 34.455 0 01-3.369 3.765l-.454.429-.37.333a.766.766 0 01-.999 0l-.371-.333a34.455 34.455 0 01-3.822-4.193C4.597 15.843 3 12.348 3 8.98 3 4.022 7.001 0 11.936 0zm0 1.532c-4.087 0-7.404 3.334-7.404 7.448 0 2.965 1.467 6.173 3.926 9.375a32.939 32.939 0 003.216 3.595l.262.248.338-.322.395-.391a32.939 32.939 0 002.745-3.13c2.46-3.202 3.926-6.41 3.926-9.375 0-4.115-3.315-7.448-7.404-7.448zm0 3.65a3.83 3.83 0 110 7.66 3.83 3.83 0 010-7.66zm0 1.532a2.299 2.299 0 10.002 4.598 2.299 2.299 0 00-.002-4.598z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgMapMarker;
exports.default = _default;